import React from "react";
import { Box, SelectField, Stack, Text } from "@origin-digital/ods-core";
import { EligibilityTextField } from "./EligibilityTextField";
import {
  connectableAustralianStates,
  premiseTypes,
  streetSuffixes,
  streetTypeOptions,
} from "src/components/Form/FormComponents/AddressConstants";
import { useFormikContext } from "formik";
import { UpdateEligibilityFormValues } from "./types";

function InternetConnectionAddress() {
  const { values, setFieldValue, errors, isSubmitting } =
    useFormikContext<UpdateEligibilityFormValues>();

  return (
    <Stack space="medium">
      <Text weight="medium">Enter the internet connection address</Text>

      <Box
        display="flex"
        gap={{
          xs: "medium",
          sm: "small",
        }}
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        <EligibilityTextField
          id="lotNumber"
          label="Lot no."
          value={values.lotNumber}
          fieldName="lotNumber"
          helperText={errors.lotNumber ? errors.lotNumber : "Optional"}
          hasError={!!errors.lotNumber}
          readOnly={isSubmitting}
        />
        <EligibilityTextField
          id="unitNumber"
          label="Unit no."
          value={values.unitNumber}
          fieldName="unitNumber"
          helperText={errors.unitNumber ? errors.unitNumber : "Optional"}
          hasError={!!errors.unitNumber}
          readOnly={isSubmitting}
        />
      </Box>

      <Box
        display="flex"
        gap={{
          xs: "medium",
          sm: "small",
        }}
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        <SelectField
          id="premiseType"
          label="Unit type"
          value={values.premiseType}
          displayEmpty={true}
          options={premiseTypes}
          helperText={errors.premiseType ? errors.premiseType : "Optional"}
          error={!!errors.premiseType}
          onChange={(e) => {
            setFieldValue("premiseType", e.target.value);
          }}
          disabled={isSubmitting}
        />
        <EligibilityTextField
          id="streetNumber"
          label="Street no."
          value={values.streetNumber}
          fieldName="streetNumber"
          helperText={errors.streetNumber}
          hasError={!!errors.streetNumber}
          readOnly={isSubmitting}
          maxLength="10"
        />
      </Box>

      <EligibilityTextField
        id="streetName"
        label="Street name"
        value={values.streetName}
        fieldName="streetName"
        readOnly={isSubmitting}
        helperText={errors.streetName}
        hasError={!!errors.streetName}
      />

      <Box
        display="flex"
        gap={{
          xs: "medium",
          sm: "small",
        }}
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        <SelectField
          id="streetType"
          label="Street type"
          value={values.streetType}
          displayEmpty={true}
          options={streetTypeOptions}
          helperText={errors.streetType}
          error={!!errors.streetType}
          onChange={(e) => {
            setFieldValue("streetType", e.target.value);
          }}
          disabled={isSubmitting}
        />
        <SelectField
          id="street-suffix"
          label="Street type suffix"
          value={values.streetSuffix}
          displayEmpty={true}
          options={streetSuffixes}
          helperText={errors.streetSuffix ? errors.streetSuffix : "Optional"}
          error={!!errors.streetSuffix}
          onChange={(e) => {
            setFieldValue("streetSuffix", e.target.value);
          }}
          disabled={isSubmitting}
        />
      </Box>
      <EligibilityTextField
        id="suburb"
        label="City/Suburb"
        value={values.suburb}
        fieldName="suburb"
        readOnly={isSubmitting}
        helperText={errors.suburb}
        hasError={!!errors.suburb}
      />

      <Box
        display="flex"
        gap={{
          xs: "medium",
          sm: "small",
        }}
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        <SelectField
          id="state"
          label="State"
          value={values.state}
          displayEmpty={true}
          options={connectableAustralianStates}
          helperText={errors.state ? errors.state : "Optional"}
          error={!!errors.state}
          onChange={(e) => {
            setFieldValue("state", e.target.value);
          }}
          disabled={isSubmitting}
        />
        <EligibilityTextField
          id="postcode"
          label="Postcode"
          value={values.postcode}
          fieldName="postcode"
          helperText={errors.postcode}
          hasError={!!errors.postcode}
          readOnly={isSubmitting}
        />
      </Box>

      {/* <Alert tone="critical" title="Failed to update request">
            Please try again or come back later.
          </Alert> */}
    </Stack>
  );
}
export default InternetConnectionAddress;
